import { DetailsMenuAlignment } from "@/app/features/shared/detail-section/types/types";

export function positionForDetailsMenuAlignment(alignment: DetailsMenuAlignment) {
    switch (alignment) {
        case 'row': return 'top right';
        case 'row-reverse': return 'top left';
        case 'column': return 'bottom right';
        case 'column-reverse': return 'bottom left';
    }
}
